export default __webpack_public_path__ + "static/media/main-swiper-4.d19fab67.png";